import { Adapter } from "@/core/models/adapter";

/**
 * Organization types
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/!**!/enums.json
 */
export const ROOT_MANAGEMENT_UNIT = "root_management_unit";
export const MANAGEMENT_UNIT = "management_unit";
export const STORE = "store";
export const WAREHOUSE = "warehouse";
export const ORGANIZATION_TYPES_FOR_FILTER = [MANAGEMENT_UNIT, STORE, WAREHOUSE];

/**
 * Organization modules
 */

export const MODULE_ROOT = "root";
export const MODULE_TIM = "tim";
export const MODULE_RPS = "rps";

/**
 * Organization statuses
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/!**!/enums.json
 */
export const ORGANIZATION_ACTIVE = "active";
export const ORGANIZATION_INACTIVE = "inactive";
export const ORGANIZATION_STATUSES = [ORGANIZATION_ACTIVE, ORGANIZATION_INACTIVE];

export class Organization {
  constructor() {
    this.id = null;
    this.commonName = null;
    this.corporateName = null;
    this.siret = null;
    this.capital = null;
    this.street = null;
    this.streetMore = null;
    this.zipCode = null;
    this.city = null;
    this.country = null;
    this.latitude = null;
    this.longitude = null;
    this.placeEmail = null;
    this.status = null;
    this.type = null;
    this.moduleType = null;
    this.parentOrganizationId = null;
    this.externalId = null;
    this.defaultWarehouse = null;
    this.createdAt = null;
  }

  isStore() {
    return STORE === this.type;
  }

  isWarehouse() {
    return WAREHOUSE === this.type;
  }

  isActive() {
    return ORGANIZATION_ACTIVE === this.status;
  }

  /**
   * @return {string}
   */
  getJsonLdId() {
    return `/organizations/${this.id}`;
  }
}

export class OrganizationAdapter extends Adapter {
  static adapt(organizationApi) {
    const organization = new Organization();
    organization.id = organizationApi?.id;
    organization.commonName = organizationApi?.commonName;
    organization.corporateName = organizationApi?.corporateName;
    organization.siret = organizationApi?.siret;
    organization.capital = organizationApi?.capital;
    organization.street = organizationApi?.street;
    organization.streetMore = organizationApi?.streetMore;
    organization.zipCode = organizationApi?.zipCode;
    organization.city = organizationApi?.city;
    organization.country = organizationApi?.country;
    organization.latitude = organizationApi?.latitude;
    organization.longitude = organizationApi?.longitude;
    organization.placeEmail = organizationApi?.placeEmail;
    organization.status = organizationApi?.status;
    organization.type = organizationApi?.type;
    organization.externalId = organizationApi?.externalId;
    organization.moduleType = organizationApi?.moduleType ?? "root";
    organization.parentOrganizationId = organizationApi?.parentOrganizationId;

    organization.defaultWarehouse = organizationApi?.defaultWarehouse ?? null;

    organization.createdAt = organizationApi?.createdAt;

    return organization;
  }
}
